"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processNumeric = exports.isNumericValue = exports.isNumericType = exports.getFieldPayload = exports.getFieldDescription = exports.SEARCHABLE_TYPES = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _FormattedNumber = _interopRequireDefault(require("../../locale/FormattedNumber"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SEARCHABLE_TYPES = exports.SEARCHABLE_TYPES = {
  NUMERIC_SIMPLE: 'numeric',
  NUMERIC_PERCENTAGE: 'percentage',
  EXTERNAL: 'variable'
};
var processNumeric = exports.processNumeric = function processNumeric(value) {
  if (!value) return '';
  var stringValue = typeof value === 'number' ? String(value) : value;
  var processed = stringValue.replace(/^0{1,}/, '') || '0';
  return processed.indexOf('.') === 0 ? "0".concat(processed) : processed;
};
var isNumericType = exports.isNumericType = R.memoizeWith(R.identity, function (type) {
  return type === SEARCHABLE_TYPES.NUMERIC_SIMPLE || type === SEARCHABLE_TYPES.NUMERIC_PERCENTAGE;
});
var isNumericValue = exports.isNumericValue = R.memoizeWith(R.identity, function (value) {
  return /^-?([0-9]*\.?[0-9]*|[0-9]*\.?|\.?[0-9]*)$/.test(value);
});
var getNumericLocaleDescription = function getNumericLocaleDescription(_ref) {
  var type = _ref.type,
    value = _ref.value,
    isFocused = _ref.isFocused;
  var isPercentage = type === SEARCHABLE_TYPES.NUMERIC_PERCENTAGE;
  if (isFocused || value === '-') return value;
  return (0, _FormattedNumber["default"])({
    value: value,
    isPercentage: isPercentage,
    maximumFractionDigits: 5
  });
};
var getFieldDescription = exports.getFieldDescription = function getFieldDescription(_ref2) {
  var type = _ref2.type,
    value = _ref2.value,
    isFocused = _ref2.isFocused,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? '' : _ref2$description,
    _ref2$search = _ref2.search,
    search = _ref2$search === void 0 ? '' : _ref2$search,
    _ref2$displayName = _ref2.displayName,
    displayName = _ref2$displayName === void 0 ? '' : _ref2$displayName;
  var isNumeric = isNumericType(type);
  if (isNumeric) {
    return getNumericLocaleDescription({
      type: type,
      value: value,
      isFocused: isFocused
    });
  }
  if (search || displayName) return search || displayName;
  return description || displayName || value;
};
var getFieldPayload = exports.getFieldPayload = function getFieldPayload(_ref3) {
  var _ref3$value = _ref3.value,
    value = _ref3$value === void 0 ? '' : _ref3$value,
    _ref3$description = _ref3.description,
    description = _ref3$description === void 0 ? '' : _ref3$description,
    _ref3$dataSource = _ref3.dataSource,
    dataSource = _ref3$dataSource === void 0 ? '' : _ref3$dataSource,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? '' : _ref3$type,
    _ref3$dataType = _ref3.dataType,
    dataType = _ref3$dataType === void 0 ? '' : _ref3$dataType,
    _ref3$displayName = _ref3.displayName,
    displayName = _ref3$displayName === void 0 ? '' : _ref3$displayName;
  return {
    value: type === SEARCHABLE_TYPES.EXTERNAL ? "".concat(dataSource, ".").concat(value) : value,
    description: description || value,
    dataSource: dataSource || value,
    type: type,
    dataType: dataType,
    displayName: displayName || value
  };
};